export const fixedCta = () => {
  if (!document.querySelector(".js-fixed-cta")) return;

  const fixedCtaEl = document.querySelector(".js-fixed-cta");
  if (!fixedCtaEl) return;

  // メインビジュアル（mv）と footer の要素を取得
  const mv = document.querySelector(".js-mv");
  const footer = document.querySelector("footer");

  // -------------------------------
  // [1] mv の下端が80px分下に出たら背景切替（scrollイベント利用）
  // -------------------------------
  const checkMvPosition = () => {
    if (!mv) return;
    // mv の位置情報を取得
    const rect = mv.getBoundingClientRect();
    // window.innerHeight: ビューポートの下端位置
    // rect.bottom: mv の下端のビューポート内の位置
    // 条件：ビューポート下端が (mv の下端 + 80px) より下にある場合
    if (window.innerHeight > rect.bottom + 80) {
      document.body.classList.add("is-fixed-cta-white-bg");
    } else {
      document.body.classList.remove("is-fixed-cta-white-bg");
    }
  };

  // スクロールとウィンドウリサイズ時にチェックを実施
  window.addEventListener("scroll", checkMvPosition);
  window.addEventListener("resize", checkMvPosition);
  // 初回チェック
  checkMvPosition();

  // -------------------------------
  // [2] footer の IntersectionObserver
  // -------------------------------
  // footer の表示状況に応じて、CTA の固定表示クラスを付与／解除する
  if (footer) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // footer がビューポートに見えていればクラスを除去、見えてなければクラスを追加
          if (entry.isIntersecting) {
            document.body.classList.remove("is-fixed-cta-visible");
          } else {
            document.body.classList.add("is-fixed-cta-visible");
          }
        });
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
};
